var _module_exports = "<div class=\"sfx-toggle\">\n    <input ng-attr-id=\"{{$id}}\" type=\"checkbox\" ng-model=\"model\">\n    <label ng-attr-for=\"{{$id}}\"></label>\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/common/ui/toggle/toggle.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;